export { default, getIndexPageServerSideProps as getServerSideProps } from 'pages/[lang]/[...slug]';
